import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from '../common/Loader';
import { Pagination } from './Pagination';
import { adminNotification, markAllAsRead } from '../../action/AdminAction';
import { PATH } from '../../../utils/Constants';
import { paginationCount } from '../../../utils/URL';
import { getSystemDateFromUTC } from '../../../utils/Utility';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';
import {
    BRANCH_ADMIN_ROUTES_SECONDARY_PATH,
    LEVEL_TWO_ADMIN_ROUTES_SECONDARY_PATH,
    SUPER_ADMIN_ROUTES_SECONDARY_PATH,
} from '../../../utils/routes/path';
import { Student, Tutor } from '../../../utils/common/NamingTerms';
import AppConfig from '../../../utils/common/DomainConfiguration';
import LanguageContext, { LanguageProvider } from '../../../utils/common/LanguageContext';

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

class NotificationPopUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: this.props.openModal,
            notificationArray: [],
            currentPage: 1,
            totalPages: 0,
            todosPerPage: paginationCount,
            isLoading: false,
        };
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    // componentDidMount
    componentDidMount() {
        this.getNotification();
    }

    // componentWillUnmount
    componentWillUnmount() {
        this.props.opened(false);
    }

    //getNotified
    getNotified = () => {
        this.props.opened(true);
    };

    // getNotification
    getNotification(pageNumber, itemsPerPage) {
        this.isLoading();
        const values = {
            pageNumber,
            itemsPerPage,
        };
        this.props.adminNotification(values, (response) => {
            if (response) {
                this.isLoading();
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    this.getNotified();
                    this.setState({
                        notificationArray: response.response.data,
                        totalPages: response.response.totalPages,
                        currentPage: response.response.pageNumber,
                        todosPerPage: response.response.itemsPerPage,
                        read: response.response.read,
                    });
                } else {
                    this.props.showNotification(response.response_message, RESPONSE_CONSTANT.ERROR);
                }
            } else {
                this.props.showNotification(
                    RESPONSE_CONSTANT.SOMETHING_WENT_WRONG,
                    RESPONSE_CONSTANT.ERROR
                );
            }
        });
    }

    /**
     * Loading
     */
    isLoading() {
        this.setState({ isLoading: !this.state.isLoading });
    }

    //handlePageChange
    handlePageChange(event) {
        this.setState(
            {
                currentPage: Number(event.selected),
                offSetValue: Number(event.selected) * this.props.todosPerPage,
            },
            this.getNotification(Number(event.selected) + 1, 10)
        );
    }

    //handleNavigation
    handleNavigation = (item, role) => {
        const anchor = document.createElement('a');
        if (role === Tutor && item.type === RESPONSE_CONSTANT.REFERRAL_NOTIFICATION) {
            anchor.href = `${PATH.IM_PHYSICIAN.WAITINGROOM}/${item.data.receiverUserId}/${item.data.sessionId}`;
        } else if (
            role === Tutor &&
            item.type === RESPONSE_CONSTANT.SUBJECT_REFERRAL_NOTIFICATION
        ) {
            anchor.href = `${PATH.IM_PHYSICIAN.SUBJECT_REFERRAL_SUMMARY}/${item.data.receiverId}/${item.data.id}`;
        } else if (role === Tutor) {
            anchor.href = `${PATH.IM_PHYSICIAN.WAITINGROOM}/${item.data.userId}/${item.data.visitId}`;
        } else if (role === RESPONSE_CONSTANT.LEVEL_TWO_ADMIN) {
            anchor.href = `${LEVEL_TWO_ADMIN_ROUTES_SECONDARY_PATH.LEVEL_TWO_ADMIN}/${item.data.userId}${LEVEL_TWO_ADMIN_ROUTES_SECONDARY_PATH.SUMMARY}/${item.data.visitId}`;
        } else if (
            role === RESPONSE_CONSTANT.BRANCHADMIN &&
            item.type === RESPONSE_CONSTANT.STUDENT_NOTES
        ) {
            anchor.href = `${BRANCH_ADMIN_ROUTES_SECONDARY_PATH.BRANCH_ADMIN}/${item?.data?.userId}${BRANCH_ADMIN_ROUTES_SECONDARY_PATH.USER}/${item.data.studentUserId}/student`;
        } else if (role === RESPONSE_CONSTANT.BRANCHADMIN) {
            anchor.href = `${BRANCH_ADMIN_ROUTES_SECONDARY_PATH.BRANCH_ADMIN}/${item.data.userId}${BRANCH_ADMIN_ROUTES_SECONDARY_PATH.SUMMARY}/${item.data.visitId}`;
        } else if (role === Student && item.type === RESPONSE_CONSTANT.REFERRAL_NOTIFICATION) {
            anchor.href = `${PATH.IM_PATIENT.WAITINGROOM}/${item.data.receiverUserId}/${item.data.sessionId}`;
        } else if (
            role === Student &&
            item.type === RESPONSE_CONSTANT.SUBJECT_REFERRAL_NOTIFICATION
        ) {
            anchor.href = `${PATH.IM_PATIENT.SUBJECT_REFERRAL_SUMMARY}/${item.data.receiverId}/${item.data.id}`;
        } else {
            anchor.href = `${PATH.IM_PATIENT.WAITINGROOM}/${item.data.userId}/${item.data.visitId}`;
        }
        anchor.click();
    };

    //getMarkAllAsRead
    getMarkAllAsRead(item, isAllAsRead, role) {
        if (isAllAsRead || (!isAllAsRead && item && !item?.read)) {
            let params = {
                id: item?.id ? item?.id : '',
                userId: item?.data?.userId ? item?.data?.userId : '',
            };
            this.props.markAllAsRead(params, (respose) => {
                if (respose) {
                    if (respose.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                        if (!isAllAsRead) {
                            this.handleNavigation(item, role);
                        } else {
                            this.props.getnotificationCount();
                            this.getNotification();
                        }
                    } else {
                        this.props.showNotification(
                            respose.response_message,
                            RESPONSE_CONSTANT.ERROR
                        );
                    }
                }
            });
        } else {
            this.handleNavigation(item, role);
        }
    }

    render() {
        const { notificationArray } = this.state;
        return (
            <div className="">
                {this.state.isLoading ? (
                    <Loader />
                ) : (
                    <div className="notify-height bg-[#181B22]">
                        <div className="flex items-center justify-between mb-6">
                            <h6 className="text-lg font-semibold text-white">
                                {this.props.t('allNotifications')}
                            </h6>
                            {this.props.notificationUnreadCount !== 0 && (
                                <button
                                    className="underline cursor-pointer text-collabotxt"
                                    onClick={() =>
                                        this.getMarkAllAsRead(null, true, this.props.role)
                                    }
                                >
                                    {this.props.t('markAllAsRead')}
                                </button>
                            )}
                        </div>
                        {!this.state.notificationArray.length && (
                            <div>
                                <h6 className="text-white">
                                    {this.props.t('noNotificationsFound')}
                                </h6>
                            </div>
                        )}
                        <article>
                            {this.props.role === Tutor
                                ? notificationArray.map((item) => {
                                      sessionStorage.setItem(item.data.id, 'SubjectId');
                                      return (
                                          //eslint-disable-next-line
                                          <a
                                              key={item.id}
                                              onClick={() =>
                                                  this.getMarkAllAsRead(
                                                      item,
                                                      false,
                                                      this.props.role
                                                  )
                                              }
                                              className="text-white no-underline cursor-pointer"
                                          >
                                              <div
                                                  className="flex items-center gap-3 px-2 py-1 mb-4 border-b border-gray-700 notification-popup"
                                                  style={{
                                                      fontWeight: item.read ? '' : 'bold',
                                                  }}
                                              >
                                                  <div className="flex items-center justify-center w-8 h-8 bg-[#23262D] rounded-full">
                                                      <svg
                                                          width="24"
                                                          height="24"
                                                          viewBox="0 0 24 24"
                                                          fill="none"
                                                          xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                          <path
                                                              d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                                                              stroke="#289E57"
                                                              strokeWidth="1.5"
                                                              strokeLinecap="round"
                                                              strokeLinejoin="round"
                                                          />
                                                          <path
                                                              d="M7.75 11.9999L10.58 14.8299L16.25 9.16992"
                                                              stroke="#289E57"
                                                              strokeWidth="1.5"
                                                              strokeLinecap="round"
                                                              strokeLinejoin="round"
                                                          />
                                                      </svg>
                                                  </div>
                                                  {item.type ===
                                                      RESPONSE_CONSTANT.APPOINTMENT_CONFIRMATION ||
                                                  item.type ===
                                                      RESPONSE_CONSTANT.IN_PERSON_CONFIRMATION ? (
                                                      <div>
                                                          <p
                                                              className="text-white"
                                                              style={{ marginBottom: '0' }}
                                                          >
                                                              {this.props.t(
                                                                  'youHaveSessionScheduledWith'
                                                              )}{' '}
                                                              <span
                                                                  className="mr-2 truncate"
                                                                  title={item.data.name}
                                                              >
                                                                  {item.data.name.length > 10
                                                                      ? `${item.data.name.slice(0, 10)}...`
                                                                      : item.data.name}
                                                              </span>
                                                          </p>
                                                          <span className="ml-auto text-xs text-white whitespace-normal text-end">
                                                              {getSystemDateFromUTC(
                                                                  item.data.appointmentStartTime,
                                                                  this.props.profileTimezone
                                                              )}
                                                          </span>
                                                      </div>
                                                  ) : item.type ===
                                                    RESPONSE_CONSTANT.TUTOR_VERIFICATION ? (
                                                      <p
                                                          className="text-white"
                                                          style={{ marginBottom: '0' }}
                                                      >
                                                          {this.props.t('accountHasBeenVerifiedBy')}{' '}
                                                          <span
                                                              style={{ fontWeight: '600' }}
                                                              title={item.data.name}
                                                          >
                                                              {item.data.name.length > 10
                                                                  ? `${item.data.name.slice(0, 10)}...`
                                                                  : item.data.name}
                                                          </span>
                                                      </p>
                                                  ) : item.type ===
                                                    RESPONSE_CONSTANT.APPOINTMENT_CANCEL ? (
                                                      <div>
                                                          <p
                                                              className="text-white"
                                                              style={{ marginBottom: '0' }}
                                                          >
                                                              {this.props.t('yourSessionWith')}{' '}
                                                              <span
                                                                  className="mr-2"
                                                                  title={item.data.name}
                                                              >
                                                                  {item.data.name.length > 10
                                                                      ? `${item.data.name.slice(0, 10)}...`
                                                                      : item.data.name}{' '}
                                                                  {this.props.t('hasBeenCancelled')}
                                                              </span>
                                                          </p>
                                                          <span className="ml-auto text-xs whitespace-normal text-end">
                                                              {getSystemDateFromUTC(
                                                                  item.data.appointmentStartTime,
                                                                  this.props.profileTimezone
                                                              )}
                                                          </span>
                                                      </div>
                                                  ) : item.type ===
                                                    RESPONSE_CONSTANT.APPOINTMENT_REMAINDER ? (
                                                      <div className="text-white">
                                                          <p style={{ marginBottom: '0' }}>
                                                              {this.props.t(
                                                                  'reminderOnUpcomingSessionWith'
                                                              )}{' '}
                                                              <span
                                                                  className="mr-2"
                                                                  title={item.data.name}
                                                              >
                                                                  {item.data.name.length > 10
                                                                      ? `${item.data.name.slice(0, 10)}...`
                                                                      : item.data.name}
                                                              </span>
                                                          </p>
                                                          <span className="ml-auto text-xs whitespace-normal text-end">
                                                              {getSystemDateFromUTC(
                                                                  item.data.appointmentStartTime,
                                                                  this.props.profileTimezone
                                                              )}
                                                          </span>
                                                      </div>
                                                  ) : item.type ===
                                                    RESPONSE_CONSTANT.APPOINTMENT_MISSED ? (
                                                      <div className="text-white">
                                                          <p style={{ marginBottom: '0' }}>
                                                              {this.props.t(
                                                                  'missedAppointmentWith'
                                                              )}{' '}
                                                              <span
                                                                  className="mr-2"
                                                                  title={item.data.name}
                                                              >
                                                                  {item.data.name.length > 10
                                                                      ? `${item.data.name.slice(0, 10)}...`
                                                                      : item.data.name}
                                                              </span>
                                                          </p>
                                                          <span className="ml-auto text-xs whitespace-normal text-end">
                                                              {getSystemDateFromUTC(
                                                                  item.data.appointmentStartTime,
                                                                  this.props.profileTimezone
                                                              )}
                                                          </span>
                                                      </div>
                                                  ) : item.type ===
                                                    RESPONSE_CONSTANT.CLASSROOM_REMAINDER ? (
                                                      <div className="text-white">
                                                          <p
                                                              className="mr-2"
                                                              style={{ marginBottom: '0' }}
                                                          >
                                                              {this.props.t(
                                                                  'reminderOnGroupSessionWith'
                                                              )}
                                                              {this.props
                                                                  .t('teamMembers')
                                                                  .toLowerCase()}{' '}
                                                          </p>
                                                          <span className="ml-auto text-xs whitespace-normal text-end">
                                                              {getSystemDateFromUTC(
                                                                  item.data.appointmentStartTime,
                                                                  this.props.profileTimezone
                                                              )}
                                                          </span>
                                                      </div>
                                                  ) : item.type ===
                                                    RESPONSE_CONSTANT.CLASSROOM_CANCEL ? (
                                                      <div className="text-white">
                                                          <p
                                                              className="mr-2"
                                                              style={{ marginBottom: '0' }}
                                                          >
                                                              {this.props.t('yourGroupSessionWith')}{' '}
                                                              {this.props
                                                                  .t('teamMembers')
                                                                  .toLowerCase()}
                                                              {this.props.t('hasBeenCancelled')}
                                                          </p>
                                                          <span className="ml-auto text-xs whitespace-normal text-end">
                                                              {getSystemDateFromUTC(
                                                                  item.data.appointmentStartTime,
                                                                  this.props.profileTimezone
                                                              )}
                                                          </span>
                                                      </div>
                                                  ) : item.type ===
                                                    RESPONSE_CONSTANT.CLASSROOM_CONFIRMATION ? (
                                                      <div className="text-white">
                                                          <p
                                                              className="mr-2"
                                                              style={{ marginBottom: '0' }}
                                                          >
                                                              {this.props.t(
                                                                  'youHaveGroupSessionScheduledWith'
                                                              )}
                                                              {this.props
                                                                  .t('teamMembers')
                                                                  .toLowerCase()}
                                                          </p>
                                                          <span className="ml-auto text-xs whitespace-normal text-end">
                                                              {getSystemDateFromUTC(
                                                                  item.data.appointmentStartTime,
                                                                  this.props.profileTimezone
                                                              )}
                                                          </span>
                                                      </div>
                                                  ) : item.type ===
                                                    RESPONSE_CONSTANT.BROADCAST_CONFIRMATION ? (
                                                      <div className="text-white">
                                                          <p
                                                              className="mr-2"
                                                              style={{ marginBottom: '0' }}
                                                          >
                                                              {this.props.t(
                                                                  'youHaveLiveStreamBroadcast'
                                                              )}
                                                              {this.props.t(
                                                                  'sessionScheduledWithTeamMembers'
                                                              )}
                                                          </p>
                                                          <span className="ml-auto text-xs whitespace-normal text-end">
                                                              {getSystemDateFromUTC(
                                                                  item.data.appointmentStartTime,
                                                                  this.props.profileTimezone
                                                              )}
                                                          </span>
                                                      </div>
                                                  ) : item.type ===
                                                    RESPONSE_CONSTANT.BROADCAST_REMAINDER ? (
                                                      <div className="text-white">
                                                          <p
                                                              className="mr-2"
                                                              style={{ marginBottom: '0' }}
                                                          >
                                                              {this.props.t(
                                                                  'reminderOnLiveStreamBroadcast'
                                                              )}
                                                              {this.props.t(
                                                                  'sessionWithTeamMembers'
                                                              )}{' '}
                                                          </p>
                                                          <span className="ml-auto text-xs whitespace-normal text-end">
                                                              {getSystemDateFromUTC(
                                                                  item.data.appointmentStartTime,
                                                                  this.props.profileTimezone
                                                              )}
                                                          </span>
                                                      </div>
                                                  ) : item.type ===
                                                    RESPONSE_CONSTANT.BROADCAST_CANCEL ? (
                                                      <div className="text-white">
                                                          <p
                                                              className="mr-2"
                                                              style={{ marginBottom: '0' }}
                                                          >
                                                              {this.props.t(
                                                                  'yourLiveStreamBroadcast'
                                                              )}
                                                              {this.props.t(
                                                                  'sessionWithTeamMembersHasBeenCancelled'
                                                              )}
                                                          </p>
                                                          <span className="ml-auto text-xs whitespace-normal text-end">
                                                              {getSystemDateFromUTC(
                                                                  item.data.appointmentStartTime,
                                                                  this.props.profileTimezone
                                                              )}
                                                          </span>
                                                      </div>
                                                  ) : item.type ===
                                                    RESPONSE_CONSTANT.APPOINTMENT_WAITING_ROOM ? (
                                                      <div className="text-white">
                                                          <p
                                                              className="mr-2"
                                                              style={{ marginBottom: '0' }}
                                                          >
                                                              {this.props.t('youHaveTeamMember')}{' '}
                                                              <span
                                                                  className="mr-2"
                                                                  title={item.data.name}
                                                              >
                                                                  {item.data.name.length > 10
                                                                      ? `${item.data.name.slice(0, 10)}...`
                                                                      : item.data.name}
                                                              </span>
                                                              {this.props.t('inWaitingRoom')}
                                                          </p>
                                                          <span className="ml-auto text-xs whitespace-normal text-end">
                                                              {getSystemDateFromUTC(
                                                                  item.data.appointmentStartTime,
                                                                  this.props.profileTimezone
                                                              )}
                                                          </span>
                                                      </div>
                                                  ) : item.type ===
                                                    RESPONSE_CONSTANT.MORE_INFO_NEEDED ? (
                                                      <div className="text-white">
                                                          <p
                                                              style={{ marginBottom: '0' }}
                                                              className="mr-2"
                                                          >
                                                              {this.props.t('admin')}{' '}
                                                              <span title={item.data.name}>
                                                                  {item.data.name.length > 10
                                                                      ? `${item.data.name.slice(0, 10)}...`
                                                                      : item.data.name}
                                                              </span>{' '}
                                                              {this.props.t(
                                                                  'needsMoreInformationOnFlaggedSession'
                                                              )}
                                                          </p>
                                                          <span className="ml-auto text-xs whitespace-normal text-end">
                                                              {getSystemDateFromUTC(
                                                                  item.data.appointmentStartTime,
                                                                  this.props.profileTimezone
                                                              )}
                                                          </span>
                                                      </div>
                                                  ) : item.type ===
                                                    RESPONSE_CONSTANT.ACTION_TAKEN ? (
                                                      <div className="text-white">
                                                          <p
                                                              className="mr-2"
                                                              style={{ marginBottom: '0' }}
                                                          >
                                                              {this.props.t('admin')}{' '}
                                                              <span title={item.data.name}>
                                                                  {item.data.name.length > 10
                                                                      ? `${item.data.name.slice(0, 10)}...`
                                                                      : item.data.name}
                                                              </span>{' '}
                                                              {this.props.t(
                                                                  'hasTakenActionOnFlaggedSession'
                                                              )}
                                                          </p>
                                                          <span className="ml-auto text-xs whitespace-normal text-end">
                                                              {getSystemDateFromUTC(
                                                                  item.data.appointmentStartTime,
                                                                  this.props.profileTimezone
                                                              )}
                                                          </span>
                                                      </div>
                                                  ) : item.type ===
                                                    RESPONSE_CONSTANT.REFERRAL_NOTIFICATION ? (
                                                      <div className="text-white">
                                                          <p style={{ marginBottom: '0' }}>
                                                              <span
                                                                  className="mr-2 truncate"
                                                                  title={item.data.senderName}
                                                              >
                                                                  {item.data.senderName?.length > 10
                                                                      ? `${item.data.senderName.slice(0, 10)}...`
                                                                      : item.data.senderName}
                                                              </span>
                                                              {this.props.t(
                                                                  'referredYouForThisSessionWith'
                                                              )}{' '}
                                                              <span
                                                                  className="mr-2 truncate"
                                                                  title={item.data.studentUserName}
                                                              >
                                                                  {item.data.studentUserName
                                                                      ?.length > 10
                                                                      ? `${item.data.studentUserName.slice(
                                                                            0,
                                                                            10
                                                                        )}...`
                                                                      : item.data.studentUserName}
                                                              </span>
                                                          </p>
                                                          <span className="ml-auto text-xs whitespace-normal text-end">
                                                              {getSystemDateFromUTC(
                                                                  item.data.sessionStartTime,
                                                                  this.props.profileTimezone
                                                              )}
                                                          </span>
                                                      </div>
                                                  ) : item.type ===
                                                    RESPONSE_CONSTANT.SUBJECT_REFERRAL_NOTIFICATION ? (
                                                      <div className="text-white">
                                                          <p style={{ marginBottom: '0' }}>
                                                              {this.props.t(
                                                                  'youHaveBeenReferredBy'
                                                              )}{' '}
                                                              <span
                                                                  className="mr-2 truncate"
                                                                  title={item.data.senderUserName}
                                                              >
                                                                  {item.data.senderUserName
                                                                      ?.length > 10
                                                                      ? `${item.data.senderUserName.slice(
                                                                            0,
                                                                            10
                                                                        )}...`
                                                                      : item.data.senderUserName}
                                                              </span>
                                                              {this.props.t('forChannel')}{' '}
                                                              <span
                                                                  className="mr-2 truncate"
                                                                  title={item.data.subject}
                                                              >
                                                                  {item.data.subject?.length > 10
                                                                      ? `${item.data.subject.slice(0, 10)}...`
                                                                      : item.data.subject}{' '}
                                                                  {AppConfig.labels.channel1}
                                                              </span>
                                                          </p>
                                                          <span className="ml-auto text-xs whitespace-normal text-end">
                                                              {getSystemDateFromUTC(
                                                                  item.data.sessionStartTime,
                                                                  this.props.profileTimezone
                                                              )}
                                                          </span>
                                                      </div>
                                                  ) : item.type ===
                                                    RESPONSE_CONSTANT.APPOINTMENT_RESCHEDULED ? (
                                                      <div className="text-white">
                                                          <p
                                                              className="mr-2"
                                                              style={{ marginBottom: '0' }}
                                                          >
                                                              {`${this.props.t('youHaveSessionScheduledWith')} ${this.props
                                                                  .t('teamMembers')
                                                                  .toLowerCase()}`}
                                                          </p>
                                                          <span className="ml-auto text-xs whitespace-normal text-end">
                                                              {getSystemDateFromUTC(
                                                                  item.data.appointmentStartTime,
                                                                  this.props.profileTimezone
                                                              )}
                                                          </span>
                                                      </div>
                                                  ) : (
                                                      ''
                                                  )}
                                              </div>
                                          </a>
                                      );
                                  })
                                : this.props.role === Student || this.props.role === 'PARENT'
                                  ? notificationArray.map((item) => (
                                        //eslint-disable-next-line
                                        <a
                                            key={item.id}
                                            onClick={() =>
                                                this.getMarkAllAsRead(item, false, this.props.role)
                                            }
                                            className="text-white no-underline cursor-pointer"
                                        >
                                            <div
                                                className="flex items-center gap-3 px-2 py-1 mb-4 border-b border-gray-700 notification-popup"
                                                style={{
                                                    fontWeight: item.read ? '' : 'bold',
                                                }}
                                            >
                                                <div className="flex items-center justify-center w-8 h-8 bg-[#23262D] rounded-full">
                                                    <svg
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                                                            stroke="#289E57"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        <path
                                                            d="M7.75 11.9999L10.58 14.8299L16.25 9.16992"
                                                            stroke="#289E57"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </div>
                                                {item.type ===
                                                    RESPONSE_CONSTANT.APPOINTMENT_CONFIRMATION ||
                                                item.type ===
                                                    RESPONSE_CONSTANT.IN_PERSON_CONFIRMATION ? (
                                                    <div>
                                                        <p style={{ marginBottom: '0' }}>
                                                            You have a session scheduled with{' '}
                                                            <span
                                                                className="mr-2 truncate"
                                                                title={item.data.name}
                                                            >
                                                                {item.data.name.length > 10
                                                                    ? `${item.data.name.slice(0, 10)}...`
                                                                    : item.data.name}
                                                            </span>
                                                        </p>
                                                        <span className="ml-auto text-xs whitespace-normal text-end">
                                                            {getSystemDateFromUTC(
                                                                item.data.appointmentStartTime,
                                                                this.props.profileTimezone
                                                            )}
                                                        </span>
                                                    </div>
                                                ) : item.type ===
                                                  RESPONSE_CONSTANT.APPOINTMENT_REFUND ? (
                                                    <p style={{ marginBottom: '0' }}>
                                                        {this.props.t(
                                                            'refundRaisedSuccessfully'
                                                        )}{' '}
                                                    </p>
                                                ) : item.type ===
                                                  RESPONSE_CONSTANT.APPOINTMENT_CANCEL ? (
                                                    <div>
                                                        <p style={{ marginBottom: '0' }}>
                                                            {this.props.t('yourSessionWith')}{' '}
                                                            <span
                                                                className="mr-2"
                                                                title={item.data.name}
                                                            >
                                                                {item.data.name.length > 10
                                                                    ? `${item.data.name.slice(0, 10)}...`
                                                                    : item.data.name}{' '}
                                                                {this.props.t('hasBeenCancelled')}
                                                            </span>
                                                        </p>
                                                        <span className="ml-auto text-xs whitespace-normal text-end">
                                                            {getSystemDateFromUTC(
                                                                item.data.appointmentStartTime,
                                                                this.props.profileTimezone
                                                            )}
                                                        </span>
                                                    </div>
                                                ) : item.type ===
                                                  RESPONSE_CONSTANT.APPOINTMENT_REMAINDER ? (
                                                    <div>
                                                        <p style={{ marginBottom: '0' }}>
                                                            {this.props.t(
                                                                'reminderOnUpcomingSessionWith'
                                                            )}{' '}
                                                            <span
                                                                className="mr-2"
                                                                title={item.data.name}
                                                            >
                                                                {item.data.name.length > 10
                                                                    ? `${item.data.name.slice(0, 10)}...`
                                                                    : item.data.name}
                                                            </span>
                                                        </p>
                                                        <span className="ml-auto text-xs whitespace-normal text-end">
                                                            {getSystemDateFromUTC(
                                                                item.data.appointmentStartTime,
                                                                this.props.profileTimezone
                                                            )}
                                                        </span>
                                                    </div>
                                                ) : item.type ===
                                                  RESPONSE_CONSTANT.APPOINTMENT_MISSED ? (
                                                    <div>
                                                        <p style={{ marginBottom: '0' }}>
                                                            {this.props.t('missedAppointmentWith')}{' '}
                                                            <span
                                                                className="mr-2"
                                                                title={item.data.name}
                                                            >
                                                                {item.data.name.length > 10
                                                                    ? `${item.data.name.slice(0, 10)}...`
                                                                    : item.data.name}
                                                            </span>
                                                        </p>{' '}
                                                        <span className="ml-auto text-xs whitespace-normal text-end">
                                                            {getSystemDateFromUTC(
                                                                item.data.appointmentStartTime,
                                                                this.props.profileTimezone
                                                            )}
                                                        </span>
                                                    </div>
                                                ) : item.type ===
                                                  RESPONSE_CONSTANT.CLASSROOM_CONFIRMATION ? (
                                                    <div>
                                                        <p style={{ marginBottom: '0' }}>
                                                            You have a session scheduled with{' '}
                                                            <span
                                                                className="mr-2 truncate"
                                                                title={item.data.name}
                                                            >
                                                                {item.data.name.length > 10
                                                                    ? `${item.data.name.slice(0, 10)}...`
                                                                    : item.data.name}
                                                            </span>
                                                        </p>
                                                        <span className="ml-auto text-xs whitespace-normal text-end">
                                                            {getSystemDateFromUTC(
                                                                item.data.appointmentStartTime,
                                                                this.props.profileTimezone
                                                            )}
                                                        </span>
                                                    </div>
                                                ) : item.type ===
                                                  RESPONSE_CONSTANT.BROADCAST_CONFIRMATION ? (
                                                    <div>
                                                        <p style={{ marginBottom: '0' }}>
                                                            {this.props.t(
                                                                'youHaveLiveStreamBroadcast'
                                                            )}
                                                            {this.props.t(
                                                                'sessionScheduledWithOwner'
                                                            )}{' '}
                                                            <span
                                                                className="mr-2"
                                                                title={item.data.name}
                                                            >
                                                                {item.data.name.length > 10
                                                                    ? `${item.data.name.slice(0, 10)}...`
                                                                    : item.data.name}
                                                            </span>
                                                        </p>
                                                        <span className="ml-auto text-xs whitespace-normal text-end">
                                                            {getSystemDateFromUTC(
                                                                item.data.appointmentStartTime,
                                                                this.props.profileTimezone
                                                            )}
                                                        </span>
                                                    </div>
                                                ) : item.type ===
                                                  RESPONSE_CONSTANT.BROADCAST_REMAINDER ? (
                                                    <div>
                                                        {' '}
                                                        <p style={{ marginBottom: '0' }}>
                                                            {this.props.t(
                                                                'reminderOnLiveStreamBroadcast'
                                                            )}
                                                            {this.props.t('sessionWithOwner')}{' '}
                                                            <span
                                                                className="mr-2"
                                                                title={item.data.name}
                                                            >
                                                                {item.data.name.length > 10
                                                                    ? `${item.data.name.slice(0, 10)}...`
                                                                    : item.data.name}
                                                            </span>
                                                        </p>{' '}
                                                        <span className="ml-auto text-xs whitespace-normal text-end">
                                                            {getSystemDateFromUTC(
                                                                item.data.appointmentStartTime,
                                                                this.props.profileTimezone
                                                            )}
                                                        </span>
                                                    </div>
                                                ) : item.type ===
                                                  RESPONSE_CONSTANT.BROADCAST_CANCEL ? (
                                                    <div>
                                                        {' '}
                                                        <p style={{ marginBottom: '0' }}>
                                                            {this.props.t(
                                                                'yourLiveStreamBroadcast'
                                                            )}
                                                            {this.props.t('sessionWithOwner')}{' '}
                                                            <span
                                                                className="mr-2"
                                                                title={item.data.name}
                                                            >
                                                                {item.data.name.length > 10
                                                                    ? `${item.data.name.slice(0, 10)}...`
                                                                    : item.data.name}{' '}
                                                                {this.props.t('hasBeenCancelled')}
                                                            </span>
                                                        </p>{' '}
                                                        <span className="ml-auto text-xs whitespace-normal text-end">
                                                            {getSystemDateFromUTC(
                                                                item.data.appointmentStartTime,
                                                                this.props.profileTimezone
                                                            )}
                                                        </span>
                                                    </div>
                                                ) : item.type ===
                                                  RESPONSE_CONSTANT.CLASSROOM_CANCEL ? (
                                                    <div>
                                                        {' '}
                                                        <p style={{ marginBottom: '0' }}>
                                                            {this.props.t('yourGroupSessionWith')}{' '}
                                                            <span
                                                                className="mr-2"
                                                                title={item.data.name}
                                                            >
                                                                {item.data.name.length > 10
                                                                    ? `${item.data.name.slice(0, 10)}...`
                                                                    : item.data.name}{' '}
                                                                {this.props.t('hasBeenCancelled')}
                                                            </span>
                                                        </p>{' '}
                                                        <span className="ml-auto text-xs whitespace-normal text-end">
                                                            {getSystemDateFromUTC(
                                                                item.data.appointmentStartTime,
                                                                this.props.profileTimezone
                                                            )}
                                                        </span>
                                                    </div>
                                                ) : item.type ===
                                                  RESPONSE_CONSTANT.CLASSROOM_REMAINDER ? (
                                                    <div>
                                                        <p style={{ marginBottom: '0' }}>
                                                            {this.props.t(
                                                                'reminderOnYourSessionWith'
                                                            )}{' '}
                                                            <span
                                                                className="mr-2"
                                                                title={item.data.name}
                                                            >
                                                                {item.data.name.length > 10
                                                                    ? `${item.data.name.slice(0, 10)}...`
                                                                    : item.data.name}
                                                            </span>
                                                        </p>
                                                        <span className="ml-auto text-xs whitespace-normal text-end">
                                                            {getSystemDateFromUTC(
                                                                item.data.appointmentStartTime,
                                                                this.props.profileTimezone
                                                            )}
                                                        </span>
                                                    </div>
                                                ) : item.type ===
                                                  RESPONSE_CONSTANT.REFERRAL_NOTIFICATION ? (
                                                    <div>
                                                        <p style={{ marginBottom: '0' }}>
                                                            <span
                                                                className="mr-2 truncate"
                                                                title={item.data.senderName || ''}
                                                            >
                                                                {item.data.senderName &&
                                                                item.data.senderName.length > 10
                                                                    ? `${item.data.senderName.slice(0, 10)}...`
                                                                    : item.data.senderName || ''}
                                                            </span>{' '}
                                                            {this.props.t('referredYouTo')}{' '}
                                                            <span
                                                                className="mr-2 truncate"
                                                                title={item.data.educatorName || ''}
                                                            >
                                                                {item.data.educatorName &&
                                                                item.data.educatorName.length > 10
                                                                    ? `${item.data.educatorName.slice(0, 10)}...`
                                                                    : item.data.educatorName || ''}
                                                            </span>{' '}
                                                            {this.props.t('forThisSession')}
                                                        </p>

                                                        <span className="ml-auto text-xs whitespace-normal text-end">
                                                            {getSystemDateFromUTC(
                                                                item.data.sessionStartTime,
                                                                this.props.profileTimezone
                                                            )}
                                                        </span>
                                                    </div>
                                                ) : item.type ===
                                                  RESPONSE_CONSTANT.SUBJECT_REFERRAL_NOTIFICATION ? (
                                                    <div>
                                                        <p style={{ marginBottom: '0' }}>
                                                            <span
                                                                className="mr-2 truncate"
                                                                title={
                                                                    item.data.senderUserName || ''
                                                                }
                                                            >
                                                                {item.data.senderUserName &&
                                                                item.data.senderUserName.length > 10
                                                                    ? `${item.data.senderUserName.slice(
                                                                          0,
                                                                          10
                                                                      )}...`
                                                                    : item.data.senderUserName ||
                                                                      ''}
                                                            </span>{' '}
                                                            {this.props.t('referred')}{' '}
                                                            <span
                                                                className="mr-2 truncate"
                                                                title={item.data.educatorName || ''}
                                                            >
                                                                {item.data.educatorName &&
                                                                item.data.educatorName.length > 10
                                                                    ? `${item.data.educatorName.slice(0, 10)}...`
                                                                    : item.data.educatorName || ''}
                                                            </span>{' '}
                                                            {this.props.t('forChannel')}{' '}
                                                            <span
                                                                className="mr-2 truncate"
                                                                title={item.data.subject || ''}
                                                            >
                                                                {item.data.subject &&
                                                                item.data.subject.length > 10
                                                                    ? `${item.data.subject.slice(0, 10)}...`
                                                                    : item.data.subject || ''}{' '}
                                                                {AppConfig.labels.channel1}
                                                            </span>
                                                        </p>
                                                        <span className="ml-auto text-xs whitespace-normal text-end">
                                                            {getSystemDateFromUTC(
                                                                item.data.sessionStartTime,
                                                                this.props.profileTimezone
                                                            )}
                                                        </span>
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                        </a>
                                    ))
                                  : this.props.role === 'ADMIN'
                                    ? notificationArray.map((item) => (
                                          <a
                                              key={item.id}
                                              href={`${SUPER_ADMIN_ROUTES_SECONDARY_PATH.SUPER_ADMIN}/${item.data.userId}${SUPER_ADMIN_ROUTES_SECONDARY_PATH.TUTOR_INFO}`}
                                              className="text-white no-underline"
                                          >
                                              <div
                                                  className="flex items-center gap-3 px-2 py-1 mb-4 border-b border-gray-700 notification-popup"
                                                  style={{
                                                      fontWeight: item.read ? '' : 'bold',
                                                  }}
                                              >
                                                  <div className="flex items-center justify-center w-8 h-8 bg-green/[0.25] rounded-full">
                                                      <svg
                                                          width="24"
                                                          height="24"
                                                          viewBox="0 0 24 24"
                                                          fill="none"
                                                          xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                          <path
                                                              d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                                                              stroke="#289E57"
                                                              strokeWidth="1.5"
                                                              strokeLinecap="round"
                                                              strokeLinejoin="round"
                                                          />
                                                          <path
                                                              d="M7.75 11.9999L10.58 14.8299L16.25 9.16992"
                                                              stroke="#289E57"
                                                              strokeWidth="1.5"
                                                              strokeLinecap="round"
                                                              strokeLinejoin="round"
                                                          />
                                                      </svg>
                                                  </div>
                                                  {item.type ===
                                                  RESPONSE_CONSTANT.ADMIN_RECEIVED_BACKGROUND_CHECK_REPORT ? (
                                                      <p style={{ marginBottom: '0' }}>
                                                          Received the report for Background check
                                                          of Tutor{' '}
                                                          <span
                                                              style={{ fontWeight: '600' }}
                                                              title={item.data.name}
                                                          >
                                                              {item.data.name.length > 10
                                                                  ? `${item.data.name.slice(0, 10)}...`
                                                                  : item.data.name}
                                                          </span>
                                                      </p>
                                                  ) : (
                                                      <p style={{ marginBottom: '0' }}>
                                                          Tutor{' '}
                                                          <span
                                                              style={{ fontWeight: '600' }}
                                                              title={item.data.name}
                                                          >
                                                              {item.data.name.length > 10
                                                                  ? `${item.data.name.slice(0, 10)}...`
                                                                  : item.data.name}
                                                          </span>{' '}
                                                          submitted the enrollment
                                                      </p>
                                                  )}
                                              </div>
                                          </a>
                                      ))
                                    : this.props.role === RESPONSE_CONSTANT.LEVEL_TWO_ADMIN ||
                                        this.props.role === RESPONSE_CONSTANT.BRANCHADMIN
                                      ? notificationArray.map((item) => (
                                            //eslint-disable-next-line
                                            <a
                                                key={item.id}
                                                onClick={() =>
                                                    this.getMarkAllAsRead(
                                                        item,
                                                        false,
                                                        this.props.role
                                                    )
                                                }
                                                className="text-white no-underline cursor-pointer"
                                            >
                                                <div
                                                    className="flex items-center gap-3 px-2 py-1 mb-4 border-b border-gray-700 notification-popup"
                                                    style={{
                                                        fontWeight: item.read ? '' : 'bold',
                                                    }}
                                                >
                                                    <div className="flex items-center justify-center w-8 h-8 bg-green/[0.25] rounded-full">
                                                        <svg
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                                                                stroke="#289E57"
                                                                strokeWidth="1.5"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                            <path
                                                                d="M7.75 11.9999L10.58 14.8299L16.25 9.16992"
                                                                stroke="#289E57"
                                                                strokeWidth="1.5"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </div>
                                                    {item.type ===
                                                    RESPONSE_CONSTANT.EDUCATOR_FLAGGED_SESSION ? (
                                                        <div>
                                                            <p
                                                                style={{ marginBottom: '0' }}
                                                                className="mr-2"
                                                            >
                                                                Owner{' '}
                                                                <span title={item.data.name}>
                                                                    {item.data.name.length > 10
                                                                        ? `${item.data.name.slice(0, 10)}...`
                                                                        : item.data.name}
                                                                </span>{' '}
                                                                has flagged a session
                                                            </p>
                                                            <span className="ml-auto text-xs whitespace-normal text-end">
                                                                {getSystemDateFromUTC(
                                                                    item.data.appointmentStartTime,
                                                                    this.props.profileTimezone
                                                                )}
                                                            </span>
                                                        </div>
                                                    ) : item.type ===
                                                      RESPONSE_CONSTANT.MORE_INFO_PROVIDED ? (
                                                        <div>
                                                            <p
                                                                className="mr-2"
                                                                style={{ marginBottom: '0' }}
                                                            >
                                                                Owner{' '}
                                                                <span title={item.data.name}>
                                                                    {item.data.name.length > 10
                                                                        ? `${item.data.name.slice(0, 10)}...`
                                                                        : item.data.name}
                                                                </span>{' '}
                                                                has provided more info on the
                                                                flagged session
                                                            </p>
                                                            <span className="ml-auto text-xs whitespace-normal text-end">
                                                                {getSystemDateFromUTC(
                                                                    item.data.appointmentStartTime,
                                                                    this.props.profileTimezone
                                                                )}
                                                            </span>
                                                        </div>
                                                    ) : item.type ===
                                                      RESPONSE_CONSTANT.STUDENT_NOTES ? (
                                                        <div>
                                                            <p
                                                                className="mr-2"
                                                                style={{ marginBottom: '0' }}
                                                            >
                                                                Owner{' '}
                                                                <span
                                                                    title={item.data.educatorName}
                                                                >
                                                                    {item.data.educatorName.length >
                                                                    10
                                                                        ? `${item.data.educatorName.slice(0, 10)}...`
                                                                        : item.data.educatorName}
                                                                </span>{' '}
                                                                has added notes for the Team Member{' '}
                                                                <span title={item.data.studentName}>
                                                                    {item.data.studentName.length >
                                                                    10
                                                                        ? `${item.data.studentName.slice(0, 10)}...`
                                                                        : item.data.studentName}
                                                                </span>
                                                            </p>
                                                            <span className="ml-auto text-xs whitespace-normal text-end">
                                                                {getSystemDateFromUTC(
                                                                    item.data.createdAt,
                                                                    this.props.profileTimezone
                                                                )}
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                            </a>
                                        ))
                                      : ''}
                        </article>
                        <div className="text-right">
                            {this.state.totalPages > 1 && (
                                <Pagination
                                    currentPage={this.state.currentPage}
                                    pageDisplayCount={this.state.totalPages}
                                    onPageChange={this.handlePageChange}
                                />
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const mapDispatchtoProps = (dispatch) => ({
    markAllAsRead: (params, callback) => {
        dispatch(markAllAsRead(params, callback));
    },
    adminNotification: (values, callback) => {
        dispatch(adminNotification(values, callback));
    },
});

// Profile timezone from GET api/v4/user; absent for admins, who keep the browser timezone
const mapStateToProps = (state) => ({
    profileTimezone: state.UserReducer?.userDetails?.timezone?.name,
});

const ConnectedNotificationPopUp = withLanguage(
    connect(mapStateToProps, mapDispatchtoProps)(NotificationPopUp)
);

export default (props) => (
    <LanguageProvider>
        <ConnectedNotificationPopUp {...props} />
    </LanguageProvider>
);
